import ContactSingleMessageModalController from './contact-single-message-modal';

export default class RsvpSingleMessageModalController extends ContactSingleMessageModalController {

    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);

        this.rsvp = this.extendedInformation.recipientModel;
        this.guestlist = this.extendedInformation.guestlist;
    }

    _getParametersForTemplatesStore() {
        const out = super._getParametersForTemplatesStore();

        if (this.guestlist) {
            out.onlyScoped = true;
            out.scopedGuestlists = [
                this.guestlist.id
            ];
        }

        return out;
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/rsvp/${recipient.id}`;
    }

    _getSendRequestData() {
        const out = {
            ...super._getSendRequestData(),
            recipient_type: 'rsvp',
            rsvps: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [this.recipientModel.id]
                    }
                ],
                count: 1
            }
        };

        delete out.contacts;

        return out;
    }

    _updatePreviewAttachments() {
        super._updatePreviewAttachments();

        if (!this.previewData) {
            return;
        }

        if (
            this.extendedMessageParameterModels.attach_passbook
            && this.previewData.passbook
        ) {
            const passbook = this.previewData.passbook;

            this.previewAttachments.push({
                name: passbook.passbook_label,
                action: () => {
                    this.api
                        .post(
                            `passbooks/${passbook.passbook_id}/download`,
                            {
                                id: this.guestlist,
                                rsvp_id: this.recipientsToDisplay[this.selectedDisplayIndex].id,
                                type: 'rsvp'
                            },
                            {responseType: "blob"}
                        )
                        .then(({data, headers}) => {
                            this.fileSaver.saveAs(
                                new Blob([data], {type: headers('content-type')}),
                                passbook.passbook_label
                            );
                        })
                }
            });
        }

        if (
            this.extendedMessageParameterModels.attach_ticket
            && this.previewData.tickets
        ) {
            _.each(this.previewData.tickets, (ticketInformation) => {
                this.previewAttachments.push({
                    name: ticketInformation.file.name,
                    action: () => {
                        this.api
                            .get(
                                ticketInformation.file.url,
                                {responseType: "blob"}
                            )
                            .then(({data, headers}) => {
                                this.fileSaver.saveAs(
                                    new Blob([data], {type: headers('content-type')}),
                                    ticketInformation.file.name
                                );
                            })
                    }
                });
            });
        }
    }

    _collectExtendedMessageParameters() {
        const out = super._collectExtendedMessageParameters();

        if (this.guestlist.ticket_template_id) {
            out.push({
                key: 'attach_ticket',
                label: 'Attach Ticket:',
                default: (
                    _.get(this.guestlist, 'settings.attach_ticket_to_confirmation_email', false)
                    && _.filter(
                        this.guestlist.templates,
                        (glTemplate) => {
                            return glTemplate.status === 'confirmed' && glTemplate.template_id === parseInt(this.selectedTemplateId);
                        }).length > 0
                )
            });
        }

        if (this.guestlist.passbook_id) {
            out.push({
                key: 'attach_passbook',
                label: 'Attach Wallet:',
                default: (
                    _.get(this.guestlist, 'settings.attach_passbook_to_confirmation_email', false)
                    && _.filter(
                        this.guestlist.templates,
                        (glTemplate) => {
                            return glTemplate.status === 'confirmed' && glTemplate.template_id === parseInt(this.selectedTemplateId);
                        }).length > 0
                )
            });
        }

        return out;
    }

    _handleEmptyTemplates() {
        this.modalInstance.dismiss();

        this.alert
            .animatedAlert(
                this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.title'),
                this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.content'),
                'attention',
                {
                    confirmButtonText: this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.add_template'),
                    cancelButtonText: this.translate.instant('general.buttons.cancel'),
                    confirmButtonColor: '#e01249'
                }
            )
            .then(() => {
                if (this.guestlist) {
                    this.state.go('app.guestlists.rsvps.messages.templates', {
                        gid: this.guestlist.id
                    }, {
                        reload: true
                    });
                } else {
                    this.state.go('app.templates.index', {
                        startTab: 'shared'
                    });
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/single-send/rsvp-single-message-modal.js